<template>
  <Loader v-if="loader" />
  <div class="flex" style="display: flex; justify-content: flex-start; margin: 20px">
    <InputText v-model="searchTerm" placeholder="Cerca..." class="p-inputtext p-component"
      style="width: 300px; margin-right: 10px;" />
    <Button
      :label="loader ? 'Caricamento...':'Cerca'"
      :icon="loader ? 'pi pi-spinner pi-spin':'pi pi-search'"
      class="p-button-primary"
      style="margin-right: 10px;"
      @click="onSearch"
      :disabled="loader"
    />
    <Button
      :label="allCurrentPageSelected ? 'Esporta tutto' : 'Esporta selezionati'"
      icon="pi pi-download"
      class="p-button-secondary"
      @click="exportToExcel"
      style="margin-right: 10px;"
      :disabled="selectedRows.length === 0"
    />
    <Button label="Visualizza POD" :class="{ 'active-button': activeFilter === 'pod' }" class="small-button"
      @click="setActiveFilter('pod')" />
    <Button label="Visualizza PDR" :class="{ 'active-button': activeFilter === 'pdr' }" class="small-button ml-2"
      @click="setActiveFilter('pdr')" />
  </div>
  <hr style="margin: 20px 0; border-top: 0.5px solid #ccc;" />

  <div class="table-container" style="overflow-x: auto">
    <Dialog v-model:visible="dialogVisible" modal header="Aggiungi Nuova Pratica" :style="{ width: '70rem' }">
      <div class="p-fluid">
        <div class="p-field p-grid">
          <label for="code" class="p-col-12 p-md-2"><b>Codice Pod/Pdr:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="code" v-model="nuovaPratica.code" />
          </div>
        </div>

        <!-- Nome -->
        <div class="p-field p-grid">
          <label for="nome" class="p-col-12 p-md-2"><b>Nome Referente:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="nome" v-model="nuovaPratica.nome" />
          </div>
        </div>

        <!-- Cognome -->
        <div class="p-field p-grid">
          <label for="cognome" class="p-col-12 p-md-2"><b>Cognome Referente:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="cognome" v-model="nuovaPratica.cognome" />
          </div>
        </div>

        <!-- Intestatario -->
        <div class="p-field p-grid">
          <label for="intestatario" class="p-col-12 p-md-2"><b>Intestatario:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="intestatario" v-model="nuovaPratica.intestatario" />
          </div>
        </div>

        <!-- Numero Telefono -->
        <div class="p-field p-grid">
          <label for="telefono" class="p-col-12 p-md-2"><b>Numero Telefono:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="telefono" v-model="nuovaPratica.telefono" placeholder="+39 3331234567" />
          </div>
        </div>

        <!-- Email -->
        <div class="p-field p-grid">
          <label for="email" class="p-col-12 p-md-2"><b>Email:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="email" v-model="nuovaPratica.email" type="email" />
          </div>
        </div>

        <!-- Ragione Sociale -->
        <div class="p-field p-grid">
          <label for="ragsoc" class="p-col-12 p-md-2"><b>Ragione Sociale:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="ragsoc" v-model="nuovaPratica.ragsoc" />
          </div>
        </div>

        <!-- Partita IVA -->
        <div class="p-field p-grid">
          <label for="piva" class="p-col-12 p-md-2"><b>Partita IVA:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="piva" v-model="nuovaPratica.piva" />
          </div>
        </div>

        <!-- Codice Ateco -->
        <div class="p-field p-grid">
          <label for="codiceAteco" class="p-col-12 p-md-2"><b>Codice Ateco:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="codiceAteco" v-model="nuovaPratica.codiceAteco" />
          </div>
        </div>

        <!-- Codice Fiscale -->
        <div class="p-field p-grid">
          <label for="codiceFiscale" class="p-col-12 p-md-2"><b>Codice Fiscale:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <InputText id="codiceFiscale" v-model="nuovaPratica.codiceFiscale" />
          </div>
        </div>

        <!-- Motivazione -->
        <div class="p-field p-grid">
          <label for="motivazione" class="p-col-12 p-md-2"><b>Motivazione:</b></label>
          <div class="p-col-12 p-md-4" style="margin-top: 10px">
            <Dropdown id="motivazione" v-model="nuovaPratica.motivazione" :options="motivazioni" optionLabel="label" placeholder="Seleziona motivazione" />
          </div>
        </div>
      </div>

      <div class="dialog-footer" style="text-align: center">
        <Button label="Aggiungi" icon="pi pi-plus-circle" class="p-button-success" @click="aggiungiPraticaConferma" />
      </div>
    </Dialog>
    <div v-if="showSuccessAlert" class="p-col-12 p-d-flex p-jc-center" style="
        margin-top: 20px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
      ">
      <div class="p-alert p-component p-alert-success" role="alert" style="
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          background-color: #52c41a;
          color: #fff;
          padding: 10px 20px;
        ">
        <div class="p-alert-content">Preventivo aggiunto con successo!</div>
      </div>
    </div>
    <div v-if="showSuccessAlert2" class="p-col-12 p-d-flex p-jc-center" style="
        margin-top: 20px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
      ">
      <div class="p-alert p-component p-alert-success-allegato" role="alert" style="
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          background-color: #52c41a;
          color: #fff;
          padding: 10px 20px;
        ">
        <div class="p-alert-content">Allegato caricato con successo!</div>
      </div>
    </div>

    <div v-if="filteredVerifica.length === 0">
      <p class="text-center">Non ci sono pratiche al momento.</p>
    </div>
    <DataTable 
      :value="filteredVerifica" 
      dataKey="id" 
      selectionMode="multiple" 
      v-model:selection="selectedRows"
      tableStyle="min-width: 75rem"
      :paginator="true"
      :rows="pagination.per_page"
      :totalRecords="pagination.total"
      :lazy="true"
      :first="(pagination.current_page - 1) * pagination.per_page"
      @page="onPage"
    >
      <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
      <Column header="Stato Pratica">
        <template #body="{ data }">
          <Button icon="pi pi-info-circle" @click="() => openInfoDialog(data)"></Button>
        </template>
      </Column>

      <div style="display: flex; align-items: center;  justify-content: flex-end; margin: 20px;">
        <div v-if="user && allowedIdUser.includes(user.id)" style="margin-right: 10px;">
          <Dropdown v-model="massiveSelectedStatus" :options="statiMassivi" optionLabel="stato"
            placeholder="Seleziona Stato" class="mb-4" />
        </div>
        <Button label="Applica Stato" class="ml-1" @click="applyMassiveStatusChange"
          :disabled="!(user && allowedIdUser.includes(user.id))" style="margin-right: 10px;" />
        <Button :icon="isActive ? 'pi pi-eye' : 'pi pi-eye-slash'"
          :class="['small-button', { 'active-button': isActive }]" @click="rimuoviFiltroStato"
          style="margin-right: 10px;" />
        <Button label="Aggiungi Pratica" icon="pi pi-plus" class="p-button-success" @click="aggiungiPratica" />
      </div>
      <Column field="id" header="Id Pratica"></Column>
      <Column field="data" header="Data Inserimento"></Column>
      <Column field="nome" header="Nome"></Column>
      <Column field="cognome" header="Cognome"></Column>
      <Column field="email" header="Email"></Column>
      <Column field="ragsoc" header="Ragione Sociale" style="width: 150px">
      </Column>
      <Column field="codice_fiscale" header="Codice Fiscale"></Column>
      <Column field="piva" header="Partita Iva"></Column>
      <Column header="Codice Ateco">
        <template #body="{ data }">
          <span>{{ data?.codice_ateco || data?.codiceAteco || "" }}</span>
        </template>
      </Column>
      <Column header="Code" :style="{ 'text-align': 'left' }">
        <template #body="{ data }">
          <p v-if="data.code" @click="handleButtonClick(data)" class="text-primary cursor-pointer">
            {{ data.code }}
          </p>
          <p v-else>No POD or PDR available</p>
        </template>
      </Column>
      <Column field="udd" header="UDD" editMode="cell">
        <template #body="{ data }">
          <div class="editable-cell">
            <p class="text-primary cursor-pointer" @click="startEditing(data)" v-if="data && !data.isEditing">
              {{ data && data.udd ? data.udd : "Inserisci UDD" }}
            </p>
            <input v-if="data && data.isEditing" :value="data && data.udd ? data.udd : ''"
              @input="data && (data.udd = $event.target.value)" @keydown.enter="stopEditing(data)"
              @blur="stopEditing(data)" />
          </div>
        </template>
      </Column>

      <Column field="codicePratica" header="Codice Pratica" editMode="cell">
        <template #body="{ data }">
          <div class="editable-cell">
            <p class="text-primary cursor-pointer" @click="startEditing(data)" v-if="data && !data.isEditing">
              {{
                data && data.codicePratica
                  ? data.codicePratica
                  : "Inserisci Codice Pratica"
              }}
            </p>
            <input v-if="data && data.isEditing" :value="data && data.codicePratica ? data.codicePratica : ''"
              @input="data && (data.codicePratica = $event.target.value)" @keydown.enter="stopEditing(data)"
              @blur="stopEditing(data)" />
          </div>
        </template>
      </Column>
      <Column field="motivazione" header="Motivazione"></Column>
      <Column field="numero_telefono" header="Telefono"></Column>
      <!-- <Column field="data_esecuzione" header="Da non eseguire prima del"></Column> -->
      <!-- <Column field="info_contatore" header="Info Contatore"></Column> -->
      <Column header="" style="min-width: 200px">
        <template #header>
          <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 8px;
            ">
            <span>Ultimo Stato</span>
            <Dropdown :options="statiDisponibili" optionLabel="stato" placeholder="Seleziona stato"
              v-model="selectedState" showClear @change="filterByUltimoStato" class="small-dropdown"
              style="width: 120px; font-size: 14px" />
          </div>
        </template>
        <template #body="{ data }">
          <span>
            {{ data && data.ultimo_stato ? data.ultimo_stato : 'non lavorato' }}
          </span>
        </template>
      </Column>
      <Column field="ultimaNota" header="Ultima Nota">
        <template #body="{ data }">
          <span>{{ data && data.ultima_nota ? data.ultima_nota : "" }}</span>
        </template>
      </Column>
      <Column header="Data Ultimo Stato">
        <template #body="{ data }">
          <span>{{ data && data.data_ultima_nota ? data.data_ultima_nota : "" }}</span>
        </template>
      </Column>
      <Column field="user" header="Utente"></Column>
      <Column v-if="activeFilter === 'pdr'" header="Richiesta appuntamento" style="width: 250px">
        <template #body="{ data }">
          <span
            v-if="data.appuntamento"
            :title="data.appuntamento"
            style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
          >
            {{ data.appuntamento }}
          </span>
          <span v-else class="text-500">Nessuna richiesta</span>
        </template>
      </Column>
      <Column header="Azioni" style="width: 120px">
        <template #body="{ data }">
          <div class="flex align-items-center">
            <AppuntamentoPratica v-if="activeFilter === 'pdr'" :pratica="data" tipo-pratica="verifica_contatore" :supply-code="data.code" />
            <Button 
              icon="pi pi-trash" 
              class="p-button-danger p-button-text" 
              @click="() => openDeleteDialog(data)"
              v-tooltip.left="'Elimina pratica'"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog v-model:visible="dialoginfo" modal header="Stato Pratiche" :style="{ width: '80rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" class="custom-dialog stato-dialog">
      <div class="dialog-content stato-layout">
        <div class="timeline-container">
          <Timeline v-if="timelineData && timelineData.length > 0" :value="timelineData" :key="timelineKey">
            <template #marker="slotProps">
              <span
                class="stato-punto"
                :class="{ 'stato-punto--attivo': selectedpratica.states && selectedpratica.states.length > 0 && Number(slotProps.item.numero) === Number(selectedpratica.states[0].cod_type_stato_pratica) }"
              ></span>
            </template>
            <template #content="slotProps">
              <div class="stato-passo">
                <span
                  class="stato-passo__nome"
                  :class="{ 'stato-passo__nome--attivo': selectedpratica.states && selectedpratica.states.length > 0 && Number(slotProps.item.numero) === Number(selectedpratica.states[0].cod_type_stato_pratica) }"
                >{{ slotProps.item.stato }}</span>
                <SottostatiTimeline
                  :voci="slotProps.item.sottostati"
                  :corrente="selectedpratica.states && selectedpratica.states[0] && selectedpratica.states[0].cod_type_stato_pratica"
                />
              </div>
            </template>
          </Timeline>
        </div>

                <div class="data-tables-container stato-pannello">
          <div class="stato-scheda" v-if="selectedpratica">
            <div class="stato-scheda__voce">
              <span>Pratica</span>
              <strong>Verifica contatore</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Cliente</span>
              <strong>{{
                selectedpratica.denominazione
                || [selectedpratica.nomerappresentante, selectedpratica.cognomerappresentante].filter(Boolean).join(" ")
                || [selectedpratica.NomeCliente, selectedpratica.CognomeCliente].filter(Boolean).join(" ")
                || selectedpratica.intestatario
                || "-"
              }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>POD/PDR</span>
              <strong>{{ selectedpratica.code || "-" }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Stato attuale</span>
              <strong>{{ selectedpratica.stato_corrispondente || selectedpratica.stato_pratica || "-" }}</strong>
            </div>
          </div>
          <section class="stato-blocco stato-modulo" v-if="selectedpratica">
            <h3>Aggiorna stato</h3>
            <label class="stato-campo">
              <span>Stato</span>
              <Dropdown
                v-model="selectedpratica.selectedStato"
                :options="vedeSoloPreventivo(user) ? statiSoloPreventivo : newStati"
                optionLabel="stato"
                @change="changePraticaStatus(selectedpratica)"
              />
            </label>
            <label class="stato-privato">
              <input
                type="checkbox"
                v-model="selectedpratica.privato"
                @change="changePraticaStatus(selectedpratica)"
                :true-value="1"
                :false-value="0"
                :disabled="isPrivateAutomaticallyManaged"
              />
              Privato
            </label>
            <NotaInvioDocumentazione v-model="selectedpratica.nota" :pratica="selectedpratica">
              <template #default="{ openEditor, isDocumentationState }">
                <Button
                  v-if="isDocumentationState"
                  type="button"
                  label="Inserisci documentazione"
                  icon="pi pi-file-edit"
                  @click="openEditor"
                />
                <label v-else class="stato-campo">
                  <span>Nota</span>
                  <textarea
                    class="stato-nota"
                    :value="selectedpratica.nota || ''"
                    placeholder="Inserisci la nota"
                    @input="selectedpratica.nota = $event.target.value"
                  />
                </label>
              </template>
            </NotaInvioDocumentazione>
            <button
              type="button"
              class="styled-button-Nota"
              :class="{
                'styled-button-Nota--invio': faseInvioStato === 'invio',
                'styled-button-Nota--ok': faseInvioStato === 'inviato',
              }"
              :disabled="faseInvioStato === 'invio'"
              @click="inviaStatoAnimato(selectedpratica, 'Verifica')"
            >
              <span v-if="faseInvioStato === 'invio'" class="invio-stato__spinner" aria-hidden="true"></span>
              <span v-else-if="faseInvioStato === 'inviato'" class="invio-stato__check" aria-hidden="true">✓</span>
              {{ faseInvioStato === 'invio' ? 'Invio…' : faseInvioStato === 'inviato' ? 'Inviato' : 'Invia' }}
            </button>
          </section>
          <form @submit.prevent="onSubmitFileUpload" class="form-container stato-blocco stato-file">
            <h3>File</h3>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Allegato</span>
              <div class="button-group">
              <label for="fileInput1" class="custom-file-upload" id="fileLabel1">
                Carica Allegato
              </label>
              <input
                type="file"
                id="fileInput1"
                @change="handleUploadPratiche($event)"
                class="file-input2"
              />
              <button
                v-if="selectedpratica !== null"
                @click="
                  downloadAllegatoPratica(
                    selectedpratica.id,
                    selectedpratica.code
                  )
                "
                class="custom-file-download"
              >
                Scarica Allegato
              </button>
            </div>
            </div>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Preventivo</span>
              <div class="button-group">
              <label 
                v-if="user && allowedIdUser.includes(user.id)"
                for="fileInput2" 
                class="custom-file-upload" 
                id="fileLabel2"
              >
                <i class="fas fa-cloud-upload-alt"></i> Carica Preventivo
              </label>
              <input 
                v-if="user && allowedIdUser.includes(user.id)"
                type="file" 
                id="fileInput2" 
                @change="handleFileChange($event)" 
                class="file-input" 
              />
              <button 
                v-if="selectedpratica !== null" 
                @click="downloadPreventivoPratica(selectedpratica.id)"
                class="custom-file-download"
              >
                <i class="pi pi-download"></i> Scarica Preventivo
              </button>
            </div>
            </div>
            <PreventivoFirmatoBox
              :stato="selectedpratica && selectedpratica.selectedStato"
              :pratica-id="selectedpratica && selectedpratica.id"
              type-file="Verifica"
              @file="impostaFilePreventivoFirmato"
            />
            <div class="p-alert-content" id="error-alert" style="display: none">
              Non ci sono file da scaricare.
            </div>
          </form>
          <section class="stato-blocco stato-storico">
            <h3>Storico note</h3>
            <DataTable :value="sortedStates" :paginator="true" :rows="3">
            <Column field="data_nota" header="Data"></Column>
            <Column field="stato_corrispondente" header="Stato"></Column>
            <Column field="nota" header="Nota"></Column>
            <Column field="is_private" header="Privato">
              <template #body="{ data }">
                <span 
                  v-if="data.is_private === 0" 
                  :class="canChangePrivate ? 'private-toggle cursor-pointer' : 'text-color-secondary'"
                  @click="canChangePrivate && togglePrivate(data)"
                >
                  No
                </span>
                <span 
                  v-else-if="data.is_private === 1"
                  :class="canChangePrivate ? 'private-toggle private-si cursor-pointer' : ''"
                  @click="canChangePrivate && togglePrivate(data)"
                >
                  SI
                </span>
              </template>
            </Column>
          </DataTable>
          </section>
          <section class="stato-blocco stato-importo">
            <h3>Importo</h3>
            <div v-if="preventivoEsistente" class="preventivo-esistente">
            <p><strong>Preventivo già inserito:</strong> € {{ preventivoEsistente.importo.toFixed(2) }}</p>
          </div>
          <button 
            v-else
            @click="openPreventivo" 
            class="styled-button-Nota-Preventivo"
          >
            Genera Preventivo
          </button>
          </section>
        </div>
      </div>
    </Dialog>
    <Dialog v-model:visible="preventivoDialog" modal header="Genera Preventivo" :style="{ width: '50rem' }">
      <div class="p-fluid">
        <div class="p-field p-grid mb-3">
          <label class="p-col-12"><b>Importo (€):</b></label>
          <div class="p-col-12 mt-2">
            <InputNumber v-model="importoPreventivo" mode="currency" currency="EUR" locale="it-IT" />
          </div>
        </div>

        <div class="p-field p-grid mb-2">
          <label class="p-col-12"><b>Dati Cliente:</b></label>
          <div class="p-col-12">
            <div class="cliente-info">
              <p><b>Nome:</b> {{ selectedpratica?.nome || selectedpratica?.NomeCliente || '-' }}</p>
              <p><b>Cognome:</b> {{ selectedpratica?.cognome || selectedpratica?.CognomeCliente || '-' }}</p>
              <p><b>Numero Telefono:</b> {{ selectedpratica?.numero_telefono || '-' }}</p>
              <p><b>Codice Fiscale:</b> {{ selectedpratica?.codiceFiscale || '-' }}</p>
              <p><b>Ragione Sociale:</b> {{ selectedpratica?.ragsoc || '-' }}</p>
              <p><b>Codice POD/PDR:</b> {{ selectedpratica?.code || '-' }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="preventivoDialog = false" />
        <Button label="Genera" icon="pi pi-check" class="p-button-success" @click="generaPreventivo" />
      </div>
    </Dialog>
    <Dialog 
      v-model:visible="dialogCompletamento" 
      modal 
      header="Inserisci Data Completamento" 
      :style="{ width: '30rem' }"
    >
      <div class="p-fluid">
        <div class="p-field">
          <label for="dataCompletamento"><b>Data Completamento:</b></label>
          <div style="margin-top: 10px;">
            <Calendar 
              v-model="dataCompletamento" 
              :showIcon="true" 
              dateFormat="dd/mm/yy" 
              class="w-full"
              id="dataCompletamento"
            />
          </div>
        </div>
      </div>
      <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="dialogCompletamento = false" />
        <Button label="Conferma" icon="pi pi-check" class="p-button-success" @click="confermaCompletamento" />
      </div>
    </Dialog>
    <Dialog 
      v-model:visible="dialogDelete" 
      modal 
      header="Conferma Cancellazione" 
      :style="{ width: '30rem' }"
    >
      <div class="p-fluid">
        <p>Sei sicuro di voler eliminare questa pratica?</p>
        <p v-if="praticaToDelete" class="mt-2">
          <strong>ID Pratica:</strong> {{ praticaToDelete.id }}<br>
          <strong>Codice:</strong> {{ praticaToDelete.code || '-' }}
        </p>
        <p class="mt-2 text-red-500"><strong>Questa azione non può essere annullata.</strong></p>
      </div>
      <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="dialogDelete = false" />
        <Button label="Elimina" icon="pi pi-trash" class="p-button-danger" @click="confermaDelete" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import moment from "moment";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import Loader from "@/components/Loader.vue";
import { useRoute } from "vue-router";
import * as XLSX from "xlsx";
import { useToast } from "primevue/usetoast";
import NotaInvioDocumentazione from "./NotaInvioDocumentazione.vue";
import PreventivoFirmatoBox from "./PreventivoFirmatoBox.vue";
import SottostatiTimeline from "./SottostatiTimeline.vue";
import {
  isPreventivoFirmato,
  ordinaStati,
  preparaPreventivoFirmato,
  statiBasePreventivo,
  vedeSoloPreventivo,
  timelineFromStati,
} from "@/services/ask-pratiche/preventivoFirmato";
import AppuntamentoPratica from "./AppuntamentoPratica.vue";


export default {
  components: {
    AppuntamentoPratica,
    Loader,
    NotaInvioDocumentazione,
    PreventivoFirmatoBox,
    SottostatiTimeline,
  },
  props: {
    data: Array,
    stati: Array,
  },
  setup(props) {
    const user = ref(null);
    const allowedIdUser = [6, 22, 32, 60, 49, 33];
    const route = useRoute();
    const toast = useToast();
    const get_id = route.params.id;
    const loader = ref(false);
    const service = new Service();
    const verifica = ref([]);
    const filteredVerifica = ref([]);
    const pagination = ref({
      current_page: 1,
      per_page: 30,
      total: 0,
      last_page: 1,
    });
    const cod_pod = ref("");
    const rappid = ref("");
    const clientid = ref("");
    const timelineData = ref([]);
    const newStati = ref([]);
    const dialoginfo = ref(false);
    const showSuccessAlert = ref(false);
    const showSuccessAlert2 = ref(false);
    const isActive = ref(false);
    const selectedpratica = ref({
      code: "",
      cod_pratica: "",
      privato: 1,
      value: {
        file: null,
      },
    });
    const types_stato_pratica = ref([]);
    const sortedStates = computed(() => {
      if (!selectedpratica.value || !selectedpratica.value.states) {
        return [];
      }
      return [...selectedpratica.value.states].sort((a, b) => {
        const dateA = a.data_nota ? new Date(a.data_nota) : null;
        const dateB = b.data_nota ? new Date(b.data_nota) : null;

        if (dateA && dateB) {
          return dateA - dateB; 
        }
        if (dateA && !dateB) return 1;
        if (!dateA && dateB) return -1;
        return 0;
      });
    });
    const selectedRows = ref([]);
    const massiveSelectedStatus = ref(null);
    const searchTerm = ref("");
    const statiDisponibili = ref([
      { stato: "Non Lavorato", value: "non_lavorato" },
      { stato: "Acquisizione", value: "Acquisizione" },
      { stato: "in lavorazione", value: "in lavorazione" },
      { stato: "prima pianificazione", value: "prima pianificazione" },
      { stato: "sopralluogo", value: "sopralluogo" },
      { stato: "preventivo", value: "preventivo" },
      { stato: "preventivo firmato", value: "preventivo firmato" },
      {
        stato: "adempimenti ed autorizzazioni",
        value: "adempimenti ed autorizzazioni",
      },
      { stato: "seconda pianificazione", value: "seconda pianificazione" },
      { stato: "esecuzione intervento", value: "esecuzione intervento" },
      { stato: "completamento", value: "completamento" },
      { stato: "ko", value: "ko" },
    ]);
    const timelineKey = ref(0);
    const currentRecordIndex = ref(null);
    const dialogVisible = ref(false);
    const nuovaPratica = ref({
      code: '',
      nome: '',
      cognome: '',
      intestatario: '',
      telefono: '',
      email: '',
      ragsoc: '',
      piva: '',
      codiceAteco: '',
      codiceFiscale: '',
      motivazione: null
    });
    const currentDate = new Date();
    const defaultDate = ref(
      currentDate.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
    );
    const activeFilter = ref(null);
    const selectedState = ref(null);
    const preventivoDialog = ref(false);
    const importoPreventivo = ref(null);
    const preventivoData = ref({
      cod_cliente: null,
      cod_pratica: null, 
      importo: null,
      stato: 0,
      type_pratica: 'Verifica',
      creation_time: null
    });
    const preventivoEsistente = ref(null);
    const dialogCompletamento = ref(false);
    const dataCompletamento = ref(null);
    const praticaInCompletamento = ref(null);
    const motivazioni = ref([
      { label: 'Guasti/sbalzi di tensione intermittenti e non continuativi', value: 'Guasti/sbalzi di tensione intermittenti e non continuativi' },
      { label: 'Contatori che emettono calore e/o rumore', value: 'Contatori che emettono calore e/o rumore' },
      { label: 'Display guasto', value: 'Display guasto' },
      { label: 'Contatore che segnala anomalia con indicazione sul display', value: 'Contatore che segnala anomalia con indicazione sul display' },
      { label: 'Segni di evidente manomissione', value: 'Segni di evidente manomissione' },
      { label: 'Consumi Anomali', value: 'Consumi Anomali' }
    ]);

    const onSearch = () => {
      loadPage(1);
    };

    let fetchFilesInterval = null;

    onMounted(() => {
      types_stato_pratica.value = ordinaStati(props.stati);
      newStati.value = [...types_stato_pratica.value];

      if (props.data && Array.isArray(props.data.files)) {
        const initial = props.data;

        if (initial.pagination) {
          pagination.value = {
            current_page: initial.pagination.current_page || 1,
            per_page: initial.pagination.per_page || 30,
            total: initial.pagination.total || initial.files.length,
            last_page: initial.pagination.last_page || 1,
          };
        } else {
          pagination.value = {
            current_page: 1,
            per_page: 30,
            total: initial.files.length,
            last_page: 1,
          };
        }

        fetchUploadedFiles(initial.files);
        fetchCurrentStatus(initial.files);
      }

      fetchTimelineData(props.stati);
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        user.value = JSON.parse(atob(storedUser)).user[0];
      }
      activeFilter.value = "pod";
      filterByPOD();
      // fetchFilesInterval = setInterval(fetchUploadedFiles, 5 * 60 * 1000);
    });

    onUnmounted(() => {
      if (fetchFilesInterval) {
        clearInterval(fetchFilesInterval);
      }
    });

    const fetchUploadedFiles = async (data) => {
      try {
        const filesResponse = data || [];
        if (!filesResponse.length) {
          console.warn("Nessun dato in filesResponse per fetchUploadedFiles");
          return;
        }

        const existingFiles = verifica.value;
        filesResponse.forEach((file) => {
          if (!file.NomeCliente) file.NomeCliente = file.nomerappresentante;
          if (!file.CognomeCliente)
            file.CognomeCliente = file.cognomerappresentante;

          const existingFileIndex = existingFiles.findIndex(
            (existing) => existing.id === file.id
          );

          if (existingFileIndex !== -1) {
            existingFiles[existingFileIndex] = {
              ...existingFiles[existingFileIndex],
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles[existingFileIndex].uniqueId,
            };
          } else {
            existingFiles.push({
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles.length + 1,
            });
          }
        });

        verifica.value = existingFiles;
        filteredVerifica.value = existingFiles.filter(
          (item) =>
            item.uploaded === "yes" &&
            item.ultimo_stato !== "completamento"
        );

        loader.value = false;
      } catch (error) {
        console.error(
          "Errore durante il recupero dei file in fetchUploadedFiles:",
          error
        );
        loader.value = false;
      }
    };

    const statiSoloPreventivo = computed(() => statiBasePreventivo(newStati.value));
    const statiMassivi = computed(() =>
      (newStati.value || []).filter((stato) => !isPreventivoFirmato(stato))
    );
    const impostaFilePreventivoFirmato = (file) => {
      if (selectedpratica.value) {
        selectedpratica.value.filePreventivoFirmato = file;
      }
    };

    const applyMassiveStatusChange = async () => {
      if (isPreventivoFirmato(massiveSelectedStatus.value)) {
        toast.add({
          severity: "error",
          summary: "File obbligatorio",
          detail: "Il preventivo firmato va caricato sulla singola pratica.",
          life: 4000,
        });
        return;
      }
      if (!massiveSelectedStatus.value || selectedRows.value.length === 0) {
        return;
      }

      for (let i = 0; i < selectedRows.value.length; i++) {
        const row = selectedRows.value[i];
        const plainRow = JSON.parse(JSON.stringify(row));

        plainRow.selectedStato = massiveSelectedStatus.value;
        service.syncPrivateByNote(plainRow);
        plainRow.tipologia = plainRow.tipologia || "Verifica Contatore";

        await inviaNota(plainRow, "Verifica Contatore");
      }

      selectedRows.value = [];
      massiveSelectedStatus.value = null;

      await fetchUploadedFiles();
    };

    const rimuoviFiltroStato = () => {
      if (isActive.value) {
        filteredVerifica.value = verifica.value.filter(
          (item) => item.uploaded === "yes"
        );
      } else {
        filteredVerifica.value = verifica.value.filter(
          (item) =>
            item.uploaded === "yes" &&
            item.ultimo_stato !== "completamento"
        );
      }
      isActive.value = !isActive.value;
    };

    const fetchTimelineData = async (stati) => {
      try {
        // const response = await service.getStatoPratica();
        if (stati && Array.isArray(stati) && stati.length > 0) {
          timelineData.value = timelineFromStati(stati);
        } else {
          console.error(
            "La risposta dell'API non contiene i dati attesi:",
            stati
          );
        }
      } catch (error) {
        console.error(
          "Errore durante il recupero dei dati della timeline:",
          error
        );
      }
    };

    const fetchCurrentStatus = async (data) => {
      try {
        const filesResponse = data || [];
        if (!filesResponse.length) {
          console.warn("Nessun dato in filesResponse per fetchCurrentStatus");
          return;
        }

        const formattedFiles = filesResponse.map((file, index) => ({
          ...file,
          created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
          isTimelineVisible: false,
          uniqueId: index + 1,
          cod_type_stato_pratica: file.ultimo_cod_type_stato_pratica,
        }));
        verifica.value = formattedFiles;

        formattedFiles.forEach((pratica) => {
          const timelineItemIndex = timelineData.value.findIndex(
            (item) => item.numero === pratica.cod_type_stato_pratica
          );
          if (timelineItemIndex !== -1) {
            timelineData.value[timelineItemIndex].colore = "blue";
          }
        });
      } catch (error) {
        console.error(
          "Errore durante il recupero dei file in fetchCurrentStatus:",
          error
        );
      } finally {
        loader.value = false;
      }
    };

    const loadPage = async (page) => {
      try {
        loader.value = true;

        const statoFilter = selectedState.value
          ? selectedState.value.value
          : null;

        const search = searchTerm.value && searchTerm.value.trim() !== ""
          ? searchTerm.value.trim()
          : null;

        const response = await service.getListVerificaContatore(
          page,
          pagination.value.per_page,
          statoFilter,
          search
        );

        if (response && Array.isArray(response.files)) {
          if (response.pagination) {
            pagination.value = {
              current_page: response.pagination.current_page || page,
              per_page: response.pagination.per_page || pagination.value.per_page,
              total: response.pagination.total || response.files.length,
              last_page: response.pagination.last_page || pagination.value.last_page,
            };
          } else {
            pagination.value = {
              current_page: page,
              per_page: pagination.value.per_page,
              total: response.files.length,
              last_page: pagination.value.last_page,
            };
          }

          await fetchUploadedFiles(response.files);
          await fetchCurrentStatus(response.files);

          let list = verifica.value;
          if (activeFilter.value === "pod") {
            list = list.filter(
              (item) => item.code && item.code.toLowerCase().startsWith("it")
            );
          } else if (activeFilter.value === "pdr") {
            list = list.filter(
              (item) => item.code && !item.code.toLowerCase().startsWith("it")
            );
          }
          filteredVerifica.value = list;
        }
      } catch (error) {
        console.error("Errore durante il caricamento della pagina:", error);
      } finally {
        loader.value = false;
      }
    };

    const onPage = (event) => {
      const nextPage = event.page + 1;
      pagination.value.per_page = event.rows;
      loadPage(nextPage);
    };


    const statoToIdMap = {
      Acquisizione: 1,
      "in lavorazione": 2,
      "prima pianificazione": 3,
      sopralluogo: 4,
      preventivo: 5,
      "adempimenti ed autorizzazioni": 6,
      "seconda pianificazione": 7,
      "esecuzione intervento": 8,
      completamento: 9,
    };

    const changePraticaStatus = async (pratica) => {
      if (!pratica.selectedStato) {
        console.warn("selectedStato non è definito per la pratica:", pratica);
        return;
      }
      service.syncPrivateByNote(pratica);

      try {
        const statoId =
          pratica.selectedStato.id ??
          pratica.selectedStato.numero ??
          statoToIdMap[pratica.selectedStato.stato];
        if (statoId !== undefined) {
          console.log("Stato selezionato:", pratica.selectedStato.stato);
        } else {
          console.error("Stato non mappato:", pratica.selectedStato.stato);
        }
      } catch (error) {
        console.error(
          "Errore durante la gestione del cambio di stato della pratica:",
          error
        );
      }
    };

    const openInfoDialog = async (data) => {
      try {
        dialoginfo.value = true;
        selectedpratica.value = {
          ...data,
          privato: 1,
        };
        selectedpratica.value.currentRecordId = data.id;
        // currentRecordIndex.value = index;

        try {
          const response = await service.getPreventivoPratica(data.id, 'Verifica');
          preventivoEsistente.value = response.data;
        } catch (error) {
          preventivoEsistente.value = null;
        }

        const response = await service.getStatusPratica(data.id, "Verifica");

        if (response && response.stati && response.stati.length > 0) {
          const verificaStates = response.stati.filter(
            (state) =>
              state.type_file === "Verifica" && state.cod_pratica === data.id
          );

          if (verificaStates.length > 0) {
            selectedpratica.value.states = verificaStates;
            selectedpratica.value.stato_pratica =
              verificaStates[0].stato_corrispondente;
              selectedpratica.value.stato_corrispondente = verificaStates[0].stato_corrispondente;
              selectedpratica.value.cod_type_stato_pratica = verificaStates[0].cod_type_stato_pratica;
              timelineKey.value += 1;
          } else {
            console.error(
              `Nessuno stato trovato con type_file 'verifica' e cod_pratica '${data.id}' per la pratica:`,
              data.Tipologia
            );
            selectedpratica.value.states = [];
          }
        } else {
          console.error(
            "Nessuno stato trovato per la pratica:",
            data.Tipologia
          );
          selectedpratica.value.states = [];
        }
      } catch (error) {
        console.error(
          "Errore durante il recupero dello stato della pratica:",
          error
        );
        selectedpratica.value.states = [];
      }
    };

    const inviaNota = async (rowData, typefile = "Verifica") => {
      try {
        service.syncPrivateByNote(rowData);

        if (rowData.selectedStato?.stato === "completamento") {
          praticaInCompletamento.value = rowData;
          dialogCompletamento.value = true;
          return; 
        }

        const preventivoOk = await preparaPreventivoFirmato({
          service,
          row: rowData,
          typeFile: typefile,
          toast,
          lista: verifica.value,
        });
        if (!preventivoOk) {
          return;
        }

        if (!rowData || !rowData.id) {
          console.error("rowData o id_pratica non è definito");
          return;
        }

        const privato = rowData.privato ?? 1;
        const partiNome = [];

        if (rowData.nome || rowData.cognome) {
          const nomeCognome = `${rowData.nome || ""} ${rowData.cognome || ""}`.trim();
          if (nomeCognome) partiNome.push(nomeCognome);
        } else if (rowData.NomeCliente || rowData.CognomeCliente) {
          const nomeCognomeCliente = `${rowData.NomeCliente || ""} ${rowData.CognomeCliente || ""}`.trim();
          if (nomeCognomeCliente) partiNome.push(nomeCognomeCliente);
        }

        if (rowData.intestatario) {
          partiNome.push(rowData.intestatario);
        }

        if (rowData.ragsoc || rowData.ragionesociale) {
          partiNome.push(rowData.ragsoc || rowData.ragionesociale);
        }

        const nomeCompleto =
          partiNome.length > 0
            ? partiNome.join(" - ")
            : "Nome completo non disponibile";

        await service.aggiornaNotePratica({
          id_pratica: rowData.id,
          nota: rowData.nota || "",
          new_status: rowData.selectedStato,
          stato_nome: rowData.selectedStato?.stato,
          nome_completo: nomeCompleto,
          privato: privato,
          typefile: typefile,
          code: rowData.code,
          tipologia: rowData.tipologia || "Verifica Contatore",
        });

        rowData.nota = "";
        rowData.selectedStato = null;

      
        return true;
      } catch (error) {
        console.error("Errore durante l'aggiornamento della nota:", error);
        return false;
      }
    }


    const ricaricaDialogStato = async () => {
      if (!selectedpratica.value?.id) return;
      await openInfoDialog(selectedpratica.value, currentRecordIndex.value);
    };

    const faseInvioStato = ref("");
    const inviaStatoAnimato = async (...argomenti) => {
      if (faseInvioStato.value === "invio") {
        return;
      }
      faseInvioStato.value = "invio";
      let ok = false;
      try {
        ok = Boolean(await inviaNota(...argomenti));
      } catch (error) {
        ok = false;
      }
      if (ok) {
        try {
          await ricaricaDialogStato();
        } catch (error) {
          console.error("Errore durante il ricaricamento della pratica:", error);
        }
      }
      faseInvioStato.value = ok ? "inviato" : "";
      if (ok) {
        setTimeout(() => {
          faseInvioStato.value = "";
        }, 1400);
      }
    };

    const confermaCompletamento = async () => {
      try {
        if (!dataCompletamento.value) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Inserire la data di completamento',
            life: 3000
          });
          return;
        }

        const rowData = praticaInCompletamento.value;
        const dataFormattata = moment(dataCompletamento.value).format('YYYY-MM-DD');

        service.syncPrivateByNote(rowData);
        const privato = rowData.privato ?? 1;
        const partiNome = [];

        if (rowData.nomerappresentante || rowData.cognomerappresentante) {
          const nomeCognome = `${rowData.nomerappresentante || ""} ${rowData.cognomerappresentante || ""}`.trim();
          if (nomeCognome) partiNome.push(nomeCognome);
        } else if (rowData.NomeCliente || rowData.CognomeCliente) {
          const nomeCognomeCliente = `${rowData.NomeCliente || ""} ${rowData.CognomeCliente || ""}`.trim();
          if (nomeCognomeCliente) partiNome.push(nomeCognomeCliente);
        }

        if (rowData.intestatario) {
          partiNome.push(rowData.intestatario);
        }

        if (rowData.ragsoc || rowData.ragionesociale) {
          partiNome.push(rowData.ragsoc || rowData.ragionesociale);
        }

        const nomeCompleto =
          partiNome.length > 0
            ? partiNome.join(" - ")
            : "Nome completo non disponibile";

        const requestData = {
          id_pratica: rowData.id,
          nota: rowData.nota || "",
          new_status: rowData.selectedStato,
          stato_nome: rowData.selectedStato?.stato,
          nome_completo: nomeCompleto,
          privato: privato,
          typefile: "Verifica",
          code: rowData.code,
          tipologia: rowData.tipologia || "Verifica",
          data_completamento: dataFormattata
        };

        await service.aggiornaNotePratica(requestData);

        await service.completamentoverifica(
          rowData.id, 
          rowData.tipologia || "Verifica", 
          dataFormattata
        );

        rowData.nota = "";
        rowData.selectedStato = null;
        dialogCompletamento.value = false;
        dataCompletamento.value = null;
        praticaInCompletamento.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Pratica completata con successo',
          life: 3000
        });

      } catch (error) {
        console.error("Errore durante il completamento della pratica:", error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il completamento della pratica',
          life: 3000
        });
      }
    };

    const handleButtonClick = (data) => {
      if (data.cod_pod) {
        window.open(`/ask/pods/${data.cod_pod}/dettagli`);
      } else if (data.cod_pdr) {
        window.open(`/ask/pdrs/${data.cod_pdr}/dettagli`);
      }
    };

    const handleButtonClick2 = (rappidValue) => {
      window.open(`/ask/rappresentanti/${rappidValue}/dettagli`);
    };

    const handleButtonClick3 = (clientidValue) => {
      window.open(`/ask/clienti/${clientidValue}/dettagli`);
    };

    const startEditing = (rowData) => {
      rowData.isEditing = true;
    };

    const stopEditing = async (rowData) => {
  try {
    rowData.isEditing = false;

    const response = await service.aggiungiUddECodicePratica(
      rowData.id,
      rowData.udd,
      rowData.codicePratica,
      null,
      'verifica' 
    );
    
    console.log('Risposta:', response); 
  } catch (error) {
    console.error(
      "Errore durante l'aggiornamento di UDD e Codice Pratica:",
      error
    );
  }
};

    const handleFileChange = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel2");

      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadPreventiviPratiche(file);
          showSuccessAlert.value = true;

          setTimeout(() => {
            showSuccessAlert.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
      }
    };

    const handleUploadPratiche = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel1");

      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadAllegatiPratiche(file);
          showSuccessAlert2.value = true;

          setTimeout(() => {
            showSuccessAlert2.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
      }
    };

    const uploadAllegatiPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (
          !selectedPratica ||
          !selectedPratica.code ||
          !selectedPratica.id ||
          !file
        ) {
          throw new Error("File non trovato nella pratica selezionata.");
        }

        const requestData = {
          id: selectedPratica.id,
          code: selectedPratica.code,
          file: file,
        };

        const response = await service.uploadAllegatiPraticheVerificaContatore(requestData);

        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };

    const downloadAllegatoPratica = async (id, code) => {
      try {
        await service.downloadAllegatoPraticaVerificaContatore(id, code);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del Allegato:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };

    const chooseFile = () => {
      document.getElementById("fileInput").click();
    };

    const uploadPreventiviPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (!selectedPratica || !selectedPratica.id || !file) {
          throw new Error("File non trovato nella pratica selezionata.");
        }

        const requestData = {
          id: selectedPratica.id,
          tipo: "Verifica",
          file: file,
        };
        console.log(requestData);
        const response = await service.uploadPreventiviPratiche(requestData);

        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };

    const downloadPreventivoPratica = async (id) => {
      try {
        const tipo = "Verifica";
        await service.downloadPreventivoPratica(id, tipo);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del preventivo:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };

    const showFileUploadButton = () => {
      return true;
    };

    const aggiungiPratica = () => {
      dialogVisible.value = true;
    };

    const filterByPOD = () => {
      activeFilter.value = "pod";
      filterByUltimoStato();
    };

    const filterByPDR = () => {
      activeFilter.value = "pdr";
      filterByUltimoStato();
    };

    const aggiungiPraticaConferma = async () => {
      try {
        if (!nuovaPratica.value.code || !nuovaPratica.value.motivazione) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Compilare tutti i campi obbligatori',
            life: 3000
          });
          return;
        }

        if (
          nuovaPratica.value.piva &&
          String(nuovaPratica.value.piva).trim() !== '' &&
          (!nuovaPratica.value.codiceAteco || String(nuovaPratica.value.codiceAteco).trim() === '')
        ) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Se compili la Partita IVA devi inserire anche il Codice Ateco',
            life: 3000
          });
          return;
        }

        const nuovaPraticaObj = {
          code: nuovaPratica.value.code,
          nome: nuovaPratica.value.nome,
          cognome: nuovaPratica.value.cognome,
          intestatario: nuovaPratica.value.intestatario,
          telefono: nuovaPratica.value.telefono,
          email: nuovaPratica.value.email,
          ragsoc: nuovaPratica.value.ragsoc,
          piva: nuovaPratica.value.piva,
          codiceAteco: nuovaPratica.value.codiceAteco,
          codiceFiscale: nuovaPratica.value.codiceFiscale,
          motivazione: nuovaPratica.value.motivazione
        };

        await service.aggiungiPraticaVerificaContatore(nuovaPraticaObj);

        filteredVerifica.value.push(nuovaPraticaObj);
        showSuccessAlert.value = true;
        dialogVisible.value = false;

        // Reset form
        nuovaPratica.value = {
          code: '',
          nome: '',
          cognome: '',
          intestatario: '',
          telefono: '',
          email: '',
          ragsoc: '',
          piva: '',
          codiceAteco: '',
          codiceFiscale: '',
          motivazione: null
        };

        setTimeout(() => {
          showSuccessAlert.value = false;
        }, 3000);
      } catch (error) {
        console.error("Errore durante l'aggiunta della pratica:", error);
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'aggiunta della pratica',
          life: 3000
        });
      }
    };

    const exportToExcel = async () => {
      try {
        loader.value = true;

        let sourceData = [];

        if (allCurrentPageSelected.value) {
          const statoFilter = selectedState.value
            ? selectedState.value.value
            : null;

          const search = searchTerm.value && searchTerm.value.trim() !== ""
            ? searchTerm.value.trim()
            : null;

          const response = await service.getListVerificaContatore(
            1,
            999999,
            statoFilter,
            search
          );

          let allItems = response?.files || [];

          if (activeFilter.value === "pod") {
            allItems = allItems.filter(
              (item) => item.code && item.code.toLowerCase().startsWith("it")
            );
          } else if (activeFilter.value === "pdr") {
            allItems = allItems.filter(
              (item) => item.code && !item.code.toLowerCase().startsWith("it")
            );
          }

          sourceData = allItems;
        } else {
          sourceData = selectedRows.value;
        }

        if (!sourceData.length) {
          toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "Nessun dato da esportare",
            life: 3000,
          });
          return;
        }

        const dataToExport = sourceData.map((item) => ({
          "Stato Pratica": item.ultimo_stato || "",
          "Data Inserimento": item.data || "",
          "Nome": item.nome || "",
          "Cognome": item.cognome || "",
          "Email": item.email || "",
          "Ragione Sociale": item.ragsoc || "",
          "Codice Fiscale": item.codice_fiscale || "",
          "Partita Iva": item.piva || "",
          "Codice Ateco": item.codice_ateco || item.codiceAteco || "",
          "Codice Pod/Pdr": item.code || "",
          "Motivazione": item.motivazione || "",
          "Numero Telefono": item.numero_telefono || "",
          "Ultima Nota": item.ultima_nota || "",
          "Data Ultimo Stato": item.data_ultima_nota || "",
          "Utente": item.user || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Verifica");

        XLSX.writeFile(workbook, "Pratiche_verifica.xlsx");

        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Export completato correttamente",
          life: 3000,
        });
      } catch (error) {
        console.error("Errore durante l'export:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'esportazione",
          life: 3000,
        });
      } finally {
        loader.value = false;
      }
    };

    const filterByUltimoStato = () => {
      loadPage(1);
    };

    const setActiveFilter = (filter) => {
      activeFilter.value = filter;
      filterByUltimoStato();
    };

    watch(selectedState, filterByUltimoStato);

    const openPreventivo = () => {
      preventivoDialog.value = true;
    };

    const generaPreventivo = async () => {
      try {
        if (!importoPreventivo.value) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Importo preventivo non specificato',
            life: 3000
          });
          return;
        }

        preventivoData.value = {
          cod_cliente: selectedpratica.value.clientid,
          cod_pratica: selectedpratica.value.id,
          importo: Number(importoPreventivo.value),
          stato: 0,
          type_pratica: 'verifica',
          creation_time: new Date().toISOString()
        };

        await service.salvaPreventivoPartica(preventivoData.value);

        preventivoDialog.value = false;
        importoPreventivo.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Preventivo salvato correttamente',
          life: 3000
        });

      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il salvataggio del preventivo',
          life: 3000
        });
        console.error("Errore durante la generazione del preventivo:", error.response?.data || error);
      }
    };

    const canChangePrivate = computed(() => {
      return user.value && allowedIdUser.includes(user.value.id);
    });

    const isPrivateAutomaticallyManaged = computed(() => {
      return service.getPrivateByNoteRule(
        selectedpratica.value?.selectedStato,
        selectedpratica.value?.nota
      ).isManaged;
    });

    watch(
      [
        () => selectedpratica.value?.selectedStato?.stato,
        () => selectedpratica.value?.nota,
      ],
      () => service.syncPrivateByNote(selectedpratica.value),
      { immediate: true }
    );

    const togglePrivate = async (data) => {
      if (!canChangePrivate.value) return;
      
      const newPrivateValue = data.is_private === 1 ? 0 : 1;
      
      try {
        await service.changePrivatePratica(data.id, newPrivateValue);
        data.is_private = newPrivateValue;
        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Visibilità aggiornata con successo',
          life: 3000
        });
      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'aggiornamento della visibilità',
          life: 3000
        });
      }
    };

    const dialogDelete = ref(false);
    const praticaToDelete = ref(null);

    const openDeleteDialog = (pratica) => {
      praticaToDelete.value = pratica;
      dialogDelete.value = true;
    };

    const confermaDelete = async () => {
      if (!praticaToDelete.value) return;

      try {
        loader.value = true;
        await service.deletePraticaFromId(
          'pratica_verifica_contatore',
          praticaToDelete.value.id,
          'Verifica'
        );
        
        const index = verifica.value.findIndex(p => p.id === praticaToDelete.value.id);
        if (index !== -1) {
          verifica.value.splice(index, 1);
        }
        
        const filteredIndex = filteredVerifica.value.findIndex(p => p.id === praticaToDelete.value.id);
        if (filteredIndex !== -1) {
          filteredVerifica.value.splice(filteredIndex, 1);
        }

        dialogDelete.value = false;
        praticaToDelete.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Pratica cancellata con successo',
          life: 3000
        });
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'la pratica non può essere cancellata poichè è stata già lavorata.';
        toast.add({
          severity: 'error',
          summary: errorMessage.includes('non può essere cancellata') ? 'Attenzione' : 'Errore',
          detail: errorMessage,
          life: 3000
        });
      } finally {
        loader.value = false;
      }
    };

    const allCurrentPageSelected = computed(() => {
      return (
        filteredVerifica.value.length > 0 &&
        selectedRows.value.length === filteredVerifica.value.length
      );
    });

    return {
      loader,
      toast,
      get_id,
      verifica,
      cod_pod,
      rappid,
      clientid,
      handleFileChange,
      chooseFile,
      handleButtonClick3,
      handleButtonClick,
      handleButtonClick2,
      timelineData,
      startEditing,
      stopEditing,
      fetchCurrentStatus,
      selectedpratica,
      openInfoDialog,
      dialoginfo,
      filteredVerifica,
      changePraticaStatus,
      timelineKey,
      currentRecordIndex,
      inviaNota,
      faseInvioStato,
      inviaStatoAnimato,
      statiSoloPreventivo,
      vedeSoloPreventivo,
      statiMassivi,
      impostaFilePreventivoFirmato,
      showFileUploadButton,
      uploadPreventiviPratiche,
      showSuccessAlert,
      showSuccessAlert2,
      dialogVisible,
      nuovaPratica,
      aggiungiPratica,
      aggiungiPraticaConferma,
      defaultDate,
      downloadPreventivoPratica,
      handleUploadPratiche,
      downloadAllegatoPratica,
      rimuoviFiltroStato,
      isActive,
      filterByPOD,
      filterByPDR,
      exportToExcel,
      searchTerm,
      selectedRows,
      massiveSelectedStatus,
      applyMassiveStatusChange,
      user,
      allowedIdUser,
      statiDisponibili,
      selectedState,
      filterByUltimoStato,
      activeFilter,
      setActiveFilter,
      types_stato_pratica,
      newStati,
      preventivoDialog,
      importoPreventivo,
      preventivoData,
      generaPreventivo,
      openPreventivo,
      preventivoEsistente,
      dialogCompletamento,
      dataCompletamento,
      confermaCompletamento,
      motivazioni,
      canChangePrivate,
      togglePrivate,
      dialogDelete,
      praticaToDelete,
      openDeleteDialog,
      confermaDelete,
      pagination,
      onPage,
      onSearch,
      sortedStates,
      allCurrentPageSelected,
      isPrivateAutomaticallyManaged,
    };
  },
};
</script>

<style scoped>
.filter-buttons-container .small-button {
  padding: 6px 12px;
  font-size: 14px;
}

.active-button {
  background-color: white !important;
  color: blue !important;
  border: 1px solid #0056b3;
}

#error-alert {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffcccc;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  color: #ff0000;
  z-index: 1000;
}

.p-grid .p-col-12 {
  margin-bottom: 1rem;
}

.styled-button-Nota {
  background-color: #3498db;
  border: none;
  color: white;
  padding: 14px 24px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  margin-right: 10px;
  margin-bottom: 10px;
  align-self: stretch;
}

.styled-button-Nota:hover {
  background-color: #2980b9;
}

form {
  display: flex;
  flex-direction: column;
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.custom-file-upload {
  display: inline-block;
  padding: 12px 22px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}

.custom-file-download {
  display: inline-block;
  padding: 14px 24px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}

.custom-file-upload:hover {
  background-color: #2980b9;
}

input[type="file"] {
  display: none;
}

.custom-alert {
  background-color: #4caf50;
  color: white;
  padding: 15px;
  border-radius: 5px;
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  animation: fadeInOut 2s forwards;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.custom-alert:hover,
.custom-alert:focus {
  opacity: 1;
}

.custom-alert:hover,
.custom-alert:focus {
  animation: fadeOut 2s ease-in-out forwards;
}

.button-like:hover {
  text-decoration: none;
  color: navy;
}

.table-container {
  margin-top: 20px;
  overflow-x: auto;
}

.pagination-summary {
  margin-top: 10px;
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.pagination-summary__records {
  white-space: nowrap;
}

.data-table-container {
  flex: 1;
  overflow-x: auto;
}

p.text-primary.cursor-pointer {
  cursor: pointer;
  color: #007bff;
}

.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: auto;
  max-width: 100%;
  max-height: 90vh;
  overflow: auto;
}

.popup-close {
  position: absolute;
  top: 3px;
  right: 5px;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: black;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  outline: none;
}

.nota-container {
  display: flex;
  align-items: center;
}

.nota-container input {
  flex: 1;
  margin-right: 5px;
}

.popup-close:hover {
  color: darkgray;
}

.custom-dialog .dialog-content {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.custom-dialog .timeline-container {
  flex: 0 0 280px;
  overflow: visible;
  margin: 0;
  padding: 4px 16px 4px 4px;
  border-right: 1px solid #e6ebf1;
}

.data-tables-container {
  flex: 1;
  overflow-x: auto;
}

.small-dropdown {
  font-size: 14px;
  margin-top: 5px;
  margin-left: 5px;
}

.cliente-info p {
  margin: 8px 0;
}

.styled-button-Nota-Preventivo {
  background-color: #269a4d;
  border: none;
  color: white;
  padding: 12px 18px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  
}

.preventivo-esistente {
  background-color: #269a4d;
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
}

.preventivo-esistente p {
  margin: 0;
  color: #f0f0f0;
}

.private-toggle {
  padding: 4px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: inline-block;
}

.private-toggle:hover {
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.private-si {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
}

.private-si:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  box-shadow: 0 3px 6px rgba(40, 167, 69, 0.4);
}

.cursor-pointer {
  cursor: pointer;
}


.custom-dialog :deep(.p-dialog-content) {
  padding: 0.75rem 1rem;
}

.stato-pannello {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.stato-scheda {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 8px 12px;
  background: #f4f7fb;
  border: 1px solid #e3eaf2;
  border-radius: 8px;
}

.stato-scheda__voce {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stato-scheda__voce span {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.stato-scheda__voce strong {
  color: #0f172a;
  font-size: 14px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.stato-blocco {
  padding: 10px 12px;
  border: 1px solid #e6ebf1;
  border-radius: 8px;
  background: #fff;
}

.stato-blocco h3 {
  margin: 0 0 8px;
  color: #0f3d6e;
  font-size: 14px;
}

.stato-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.stato-campo > span,
.stato-privato {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-campo :deep(.p-dropdown) {
  width: 100%;
}

.stato-privato {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.stato-nota {
  width: 100%;
  min-height: 44px;
  height: 44px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 6px 10px;
  font: inherit;
  color: #0f172a;
  box-sizing: border-box;
}

.stato-modulo .styled-button-Nota {
  align-self: flex-start;
  margin: 0;
  min-width: 96px;
  padding: 8px 16px;
}

.stato-file {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.stato-file__riga {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #eef2f6;
}

.stato-file__riga:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.stato-file__nome {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-file .button-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
}

.stato-file .custom-file-upload,
.stato-file .custom-file-download {
  width: auto;
  min-width: 148px;
  min-height: 32px;
  margin: 0 8px 0 0;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.stato-importo .styled-button-Nota-Preventivo {
  padding: 8px 14px;
  margin: 0;
}

.stato-storico :deep(.p-datatable .p-datatable-thead > tr > th),
.stato-storico :deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 0.35rem 0.6rem;
}

.stato-storico :deep(.p-paginator) {
  padding: 0.25rem 0 0;
}

.stato-importo .preventivo-esistente {
  margin-top: 0;
  padding: 8px 12px;
  font-size: 14px;
}

.stato-importo .preventivo-esistente p {
  margin: 0;
}

@media (max-width: 900px) {
  .custom-dialog.stato-dialog .dialog-content {
    flex-direction: column;
  }

  .custom-dialog.stato-dialog .timeline-container {
    flex: none;
    width: 100%;
    overflow: visible;
    border-right: none;
    border-bottom: 1px solid #e6ebf1;
  }

  .stato-scheda,
  .stato-file__riga {
    grid-template-columns: 1fr;
  }
}

.timeline-container :deep(.p-timeline-event-opposite) {
  display: none;
  flex: none;
  padding: 0;
}

.timeline-container :deep(.p-timeline-event-content) {
  padding: 0 0 12px 10px;
  line-height: 1.35;
}

.timeline-container :deep(.p-timeline-event-separator) {
  flex: none;
}

.stato-punto {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #cbd5e1;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #cbd5e1;
}

.stato-punto--attivo {
  background: #2196f3;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #2196f3;
}

.stato-passo__nome {
  display: block;
  margin-top: 1px;
  color: #475569;
  font-size: 14px;
}

.stato-passo__nome--attivo {
  color: #1565c0;
  font-weight: 700;
}


.styled-button-Nota--invio,
.styled-button-Nota--ok {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.styled-button-Nota:disabled {
  opacity: 1;
  cursor: default;
}

.styled-button-Nota--ok {
  background-color: #269a4d;
}

.invio-stato__spinner {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: invio-stato-giro 0.7s linear infinite;
}

.invio-stato__check {
  display: inline-block;
  margin-right: 6px;
  font-weight: 700;
  animation: invio-stato-pop 0.35s ease;
}

@keyframes invio-stato-giro {
  to { transform: rotate(360deg); }
}

@keyframes invio-stato-pop {
  0% { transform: scale(0.4); opacity: 0; }
  70% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
}

</style>
